module.exports = __webpack_public_path__ + "img/avatar-s-1.136cc50d.png";